import { router } from '@/plugins/1.router'
import { useRouterStore } from '@/store'

export default function () {
  const { setRouter } = useRouterStore()

  setRouter(router)
}
